export default __webpack_public_path__ + "static/media/Icons_Download Icon_White.5d626ae3.svg";